/* tslint:disable */
/* eslint-disable */
/**
 * Notes API
 * API for managing notes with tags, mentions and attachments
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NoteListItemDto } from './NoteListItemDto';
import {
    NoteListItemDtoFromJSON,
    NoteListItemDtoFromJSONTyped,
    NoteListItemDtoToJSON,
    NoteListItemDtoToJSONTyped,
} from './NoteListItemDto';

/**
 * Paginated response containing list of notes
 * @export
 * @interface GetListeNotesResponse
 */
export interface GetListeNotesResponse {
    /**
     * List of notes
     * @type {Array<NoteListItemDto>}
     * @memberof GetListeNotesResponse
     */
    items?: Array<NoteListItemDto>;
    /**
     * Total number of notes matching the query
     * @type {number}
     * @memberof GetListeNotesResponse
     */
    totalCount?: number;
}

/**
 * Check if a given object implements the GetListeNotesResponse interface.
 */
export function instanceOfGetListeNotesResponse(value: object): value is GetListeNotesResponse {
    return true;
}

export function GetListeNotesResponseFromJSON(json: any): GetListeNotesResponse {
    return GetListeNotesResponseFromJSONTyped(json, false);
}

export function GetListeNotesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetListeNotesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(NoteListItemDtoFromJSON)),
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
    };
}

export function GetListeNotesResponseToJSON(json: any): GetListeNotesResponse {
    return GetListeNotesResponseToJSONTyped(json, false);
}

export function GetListeNotesResponseToJSONTyped(value?: GetListeNotesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(NoteListItemDtoToJSON)),
        'totalCount': value['totalCount'],
    };
}

